import request from '@/utils/request'

// 查询三同企业通知公告列表
export function listStqytzgg(query) {
  return request({
    url: '/web/zlts/stqytzgg/list',
    method: 'get',
    params: query
  })
}

// 查询三同企业通知公告详细
export function getStqytzgg(recid) {
  return request({
    url: '/web/zlts/stqytzgg/' + recid,
    method: 'get'
  })
}